module.exports = __webpack_public_path__ + "5da9dd322d21c71c8941896f2f1c7a16.svg";